class PdfLibrary {
  constructor(section) {
    this.section = section;
    this.init();
  }

  init() {
    const searchInput = this.section.querySelector('#pdfSearch');
    const cards = this.section.querySelectorAll('.pdf-card');

    if (!searchInput) return;

    searchInput.addEventListener('keyup', () => {
      const query = searchInput.value.toLowerCase();
      cards.forEach(card => {
        card.style.display = card.dataset.title.includes(query) ? 'block' : 'none';
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.pdf-library').forEach(section => {
    new PdfLibrary(section);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pdf-library').forEach(function (section) {

    const cards = section.querySelectorAll('.pdf-card');
    const categoryLinks = section.querySelectorAll('.category-link');
    const searchInput = section.querySelector('#pdfSearch');

    /* ===== Category Filter ===== */
    categoryLinks.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();

        const category = this.dataset.category;

        categoryLinks.forEach(l => l.classList.remove('active'));
        this.classList.add('active');

        cards.forEach(card => {
          const match =
            category === 'all' || card.dataset.category === category;
          card.style.display = match ? 'block' : 'none';
        });
      });
    });

    /* ===== Search Filter ===== */
    if (searchInput) {
      searchInput.addEventListener('keyup', function () {
        const query = this.value.toLowerCase();

        cards.forEach(card => {
          const matchesText = card.dataset.title.includes(query);
          const activeCategory =
            section.querySelector('.category-link.active')?.dataset.category || 'all';

          const matchesCategory =
            activeCategory === 'all' ||
            card.dataset.category === activeCategory;

          card.style.display =
            matchesText && matchesCategory ? 'block' : 'none';
        });
      });
    }

  });
});